import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

// Every motion feature checks this and falls back to a static, usable state.
// Read on first render too, so nothing animates before the effect runs.
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(() => window.matchMedia?.(QUERY).matches ?? false);

  useEffect(() => {
    const query = window.matchMedia?.(QUERY);
    if (!query) return;
    setReduced(query.matches);
    const onChange = (event: MediaQueryListEvent) => setReduced(event.matches);
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, []);

  return reduced;
}
